import { createContext, useContext } from "react";
import { WidgetTypeId } from "../screens/dashboard/widgetCatalog";

export const GridStackWidgetContext = createContext<{
  widget: {
    id: string;
    type: WidgetTypeId;
  };
} | null>(null);

export function useGridStackWidgetContext() {
  const context = useContext(GridStackWidgetContext);
  if (!context) {
    throw new Error(
      "useGridStackWidgetContext must be used within a GridStackWidgetProvider"
    );
  }
  return context;
}
